import baseConfig from '../configs/base.json';

let ENV = process.env.NODE_ENV;

if (ENV === 'test') {
    ENV = 'development';
}

import devconfig from '../configs/development.json';
import devAzureConfig from '../configs/devazure.json';
import productionConfig from '../configs/production.json';
import stageAzureConfig from '../configs/stageazure.json';
import stagingConfig from '../configs/staging.json';
import { DI } from '@aurelia/kernel';

let envConfig;
switch (ENV) {
    case 'development':
        envConfig = devconfig;
        break;
    case 'devazure':
        envConfig = devAzureConfig;
        break;
    case 'production':
        envConfig = productionConfig;
        break;
    case 'stageazure':
        envConfig = stageAzureConfig;
        break;
    case 'staging':
        envConfig = stagingConfig;
        break;
}

export const IConfigService = DI.createInterface<IConfigService>(
    'IConfigService',
    (x) => x.singleton(ConfigService)
);
export interface IConfigService extends ConfigService {}

export class ConfigService {
    protected configObject;

    constructor() {
        this.configObject = { ...baseConfig, ...envConfig };
    }

    environment() {
        return ENV;
    }

    get(key, defaultValue = null) {
        let keyValue = this.configObject[key] || defaultValue;

        // return empty string if null otherwise null is appended to route which fails in prod
        if (key === 'clientApiHost' && keyValue === null) {
            keyValue = '';
        }

        return keyValue;
    }
}
